import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c5fbb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cookie-notice"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cookie-notice__title" }, "МЫ ИСПОЛЬЗУЕМ COOKIE", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cookie-notice__text" }, " Продолжая использовать наш cайт, Вы даете согласие на обработку (в т.ч. с использованием систем сбора статистики, например Яндекс.Метрика и других систем) файлов cookie, иных пользовательских данных (например сведений о Вашем ip-адресе, сведений о местоположении, типе устройства, времени посещения страницы, сведений о ресурсах сети Интернет, с которых были совершены переходы на наш сайт, сведения о Ваших действиях на сайте и других сведений). Данная информация необходима для функционирования сайта, проведения ретаргетинга и статистических исследований и обзоров. Если Вы согласны, продолжайте пользоваться сайтом, если Вы не хотите, чтобы Ваши данные обрабатывались, необходимо установить специальные настройки в браузере или покинуть сайт. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShowCookieNotice)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("button", {
          class: "cookie-notice__button base-btn base-btn--green",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setCookie && _ctx.setCookie(...args)))
        }, " Принять ")
      ]))
    : _createCommentVNode("", true)
}